module.exports = __webpack_public_path__ + "images/arr-bottom-blue.svg?6bca7a7ed034ca245b51e81677f5a785";